import { render, staticRenderFns } from "./AttachmentLocation.vue?vue&type=template&id=49600a6f&scoped=true&"
import script from "./AttachmentLocation.vue?vue&type=script&lang=js&"
export * from "./AttachmentLocation.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentLocation.vue?vue&type=style&index=0&id=49600a6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49600a6f",
  null
  
)

export default component.exports